// removed by extract-text-webpack-plugin
module.exports = {"Header":"About__Header__2spzI","Logo":"About__Logo__3RO_9","BioPicture":"About__BioPicture__17qsa","BioName":"About__BioName__YvwPt","BioText":"About__BioText__22oYT"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/About/About.css
// module id = 189
// module chunks = 0